import { useTranslation } from 'react-i18next';
import { Toaster } from '@web/shared/ui/sonner';

/** The app `Toaster`, with the × label in the reader's language. Mounted once, at the root. */
export function AppToaster() {
  const { t } = useTranslation();
  return <Toaster dismissLabel={t('common.close')} />;
}
